// src/hooks/useGsapReveal.js
import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function useGsapReveal(selector = ".reveal", options = {}) {
  useEffect(() => {
    const els = gsap.utils.toArray(selector);
    if (!els.length) return;

    const anims = els.map((el) =>
      gsap.fromTo(
        el,
        { autoAlpha: 0, y: 40 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none reverse",
            ...options.scrollTrigger,
          },
          ...options,
        }
      )
    );

    return () => {
      anims.forEach((a) => a.kill());
      ScrollTrigger.getAll().forEach((st) => st.kill());
    };

  }, [selector]);
}
